import { Link } from "gatsby";
import React from "react";

type TagColor = "gray" | "teal" | "orange" | "red" | "disabled";

interface Props {
  text: string;
  color?: TagColor;
  link?: string;
  additionalClassName?: string;
}

const Tag = ({ text, color, link, additionalClassName = "" }: Props) => {
  let tagClassName;
  if (color === "gray") tagClassName = "bg-gray-300 text-gray-800";
  if (color === "teal") tagClassName = "bg-teal-50 text-teal-700";
  if (color === "orange") tagClassName = "bg-orange-100 text-orange-900";
  if (color === "red") tagClassName = "bg-red-100 text-red-900";
  if (color === "disabled" || color === undefined) {
    tagClassName = "bg-gray-200 text-gray-500";
  }

  const className = `rounded-full px-2 py-1 tracking-wide ${tagClassName} ${additionalClassName}`;

  return link ? (
    <Link className={className} to={link} data-datocms-noindex>
      {text}
    </Link>
  ) : (
    <span className={className} data-datocms-noindex>
      {text}
    </span>
  );
};

export default Tag;
